import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core'
import { EmptyFunction, isEmpty } from '../../remote'
import { ApiResult } from '../../remote-data'
import { PageLayoutComponent } from '../page-layout.component'
import { MAIN_CONTAINER_CLASS } from '../page-layout.utils'

@Component({
  selector: 'ftr-wide-header-page-layout',
  templateUrl: './wide-header-page-layout.component.html',
  styleUrls: ['./wide-header-page-layout.component.css'],
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
})
export class WideHeaderPageLayoutComponent<T> {
  @Input() name: string
  @Input() entity: ApiResult<T>
  @Input() bodyTemplate: TemplateRef<unknown>
  @Input() wideHeaderTemplate: TemplateRef<unknown> | null = null
  @Input() errorMessage?: string
  @Input() noMargin: boolean = false
  @Input() loadingTemplate: TemplateRef<any> | null = null
  @Input() emptyTemplate: TemplateRef<any> | null = null
  @Input() isEmptyFunction: EmptyFunction<T> = isEmpty

  @Output() onRetry = new EventEmitter<undefined>()

  readonly mainContainerClass = MAIN_CONTAINER_CLASS
}
